import axios from 'axios';
import { ProductTag } from 'types';

export const fetchProductTags = (brandId: number, productId: number) => {
  return axios.get<ProductTag[]>(
    `/api/brands/${brandId}/products/${productId}/tags`
  );
};
